export default __webpack_public_path__ + "static/media/virtualpad_bt_rt.92757a9d.png";